import { useState, useRef } from "react";
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import ca from 'date-fns/locale/ca';
import fr from 'date-fns/locale/fr';
import de from 'date-fns/locale/de';
import pt from 'date-fns/locale/pt';
import ru from 'date-fns/locale/ru';
import { useTranslation } from 'react-i18next';
import CustomSelect from '../Compartido/CustomSelect.jsx';
import usePreciosCalendario from '../Compartido/usePreciosCalendario.js';


const Buscador = ({ lang, destinos, capacidad_maxima }) => {

    // 'yyyy-MM-dd' local (no toISOString: evita el desfase per zona horària),
    // mateixa clau que retorna PaginasController::preciosBuscadorGeneral.
    const fechaAPreciosKey = (date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    };

    // Preus carregats a poc a poc (2 mesos cada cop) a mida que es navega
    // el calendari, en comptes de calcular-ho tot (totes les propietats
    // de la web x molts mesos) a la càrrega de la home.
    const { preciosPorDia, cargandoPrecios, carregarPreusMes } = usePreciosCalendario('/preciosbuscadorgeneral');

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    if (lang == "es")
        registerLocale('es', es)
    else if (lang == "fr")
        registerLocale('fr', fr)
    else if (lang == "ca")
        registerLocale('ca', ca)
    else if (lang == "de")
        registerLocale('de', de)
    else if (lang == "pt")
        registerLocale('pt', pt)
    else if (lang == "ru")
        registerLocale('ru', ru)
    else
        registerLocale('es', es)

    const toggleBlur = (shouldBlur) => {
        var elements = document.getElementsByClassName("potblur");
        if (shouldBlur) {
            for (var i = 0; i < elements.length; i++) {
                elements[i].classList.add('blur');
            }
        } else {
            for (var i = 0; i < elements.length; i++) {
                elements[i].classList.remove('blur');
            }
        }
    };

    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;
    const [cMeses, setCMeses] = useState(2);

    const numpersonas = useRef(null);

    const [show, setShow] = useState('');
    const handleShow = () => {
        if (show == '') {
            setShow('show');
        }
        else {
            setShow('');
        }
    };



    const [countAdults, setCountAdults] = useState(1);
    const [countNinos, setCountNinos] = useState(0);


    const handleSumaAdultos = () => {
        if (countAdults + countNinos < capacidad_maxima) {
            setCountAdults(ca => ca + 1);
            handleEtiqueta(countAdults + 1, countNinos);
        }

    }

    const handleRestaAdultos = () => {
        if (countAdults > 1) {
            setCountAdults(ca => ca - 1);
            handleEtiqueta(countAdults - 1, countNinos);
        }
    }

    const handleSumaNinos = () => {
        if (countNinos + countAdults < capacidad_maxima) {
            setCountNinos(cn => cn + 1);
            handleEtiqueta(countAdults, countNinos + 1);
        }
    }

    const handleRestaNinos = () => {
        if (countNinos > 0) {
            setCountNinos(cn => cn - 1);
            handleEtiqueta(countAdults, countNinos - 1);
        }
    }

    const handleEtiqueta = (adults, ninos) => {
        let frase = t("Escoja personas");
        if (adults == 1) frase = " " + adults + " " + t("Adulto");
        if (adults > 1) frase = " " + adults + " " + t("Adultos");
        if (ninos == 1) frase += " " + ninos + " " + t("Niño");
        if (ninos > 1) frase += " " + ninos + " " + t("Niños");

        numpersonas.current.textContent = frase;

    }

    let results3 = [];

    let objeto0 = { id: -1, name: t("Todos"), value: "" }

    results3 = results3.concat(objeto0);
    {
        destinos.forEach((undestino, index) => {
            let objeto = { id: index, name: undestino.elnombre, value: undestino.laurl }
            results3 = results3.concat(objeto);
        })
    }

    const [sheetOpen, setSheetOpen] = useState(false);


    return (
        <section className="cc-search">
            <div className="c-search">
                <div className="c-search-header">
                    <p className="c-search-header-title"> {t("ELIGE TU DESTINO")} </p>
                    <button type="button" className="btn btn-icon">
                        <span className="visually-hidden">{t("Cerrar")}</span>
                        <i className="fa-solid fa-xmark"></i>

                    </button>
                </div>
                <form noValidate="" className="c-search__wrapper c-search__wrapper--mod needs-validation ng-untouched ng-pristine ng-valid" method="get" action={"/" + preidioma + t("buscar")}>

                    <div className="body-search">
                        <div className="c-search__wrapper--grid">
                            <div ngbdropdown="" className="show-p-static dropdown">
                                <div className="input-group">
                                    <CustomSelect
                                        defaultText={t("Elige un destino")}
                                        optionsList={results3}
                                        nameInput="destino"
                                    />
                                    <div className="input-group-icon">
                                        <i className="fa-solid fa-location-dot"></i>
                                    </div>
                                </div>
                            </div>
                            <div ngbdropdown="" className="dropdown">
                                <div className="input-group">
                                    <DatePicker
                                        isClearable={true}
                                        onChange={(update) => {
                                            setDateRange(update);
                                        }}
                                        onCalendarOpen={() => {
                                            toggleBlur(true);
                                            carregarPreusMes(startDate || new Date(), cMeses);
                                        }}
                                        onCalendarClose={() => toggleBlur(false)}
                                        onMonthChange={(date) => carregarPreusMes(date, cMeses)}
                                        className="form-control cpointer noborder fs15"
                                        autoComplete="off"
                                        startDate={startDate}
                                        endDate={endDate}
                                        selectsRange={true}
                                        monthsShown={cMeses}
                                        dateFormat="dd/MM/yyyy"
                                        minDate={new Date()}
                                        placeholderText={t("DD/MM/YYYY - DD/MM/YYYY")}
                                        locale={lang}
                                        name="daterange"
                                        popperPlacement={sheetOpen ? "bottom" : "top"}
                                        popperModifiers={[
                                            {
                                                name: "flip",
                                                options: {
                                                    fallbackPlacements: [sheetOpen ? "bottom" : "top"],
                                                    allowedAutoPlacements: [sheetOpen ? "bottom" : "top"],
                                                },
                                            },
                                        ]}
                                        renderDayContents={(day, date) => {
                                            const precio = preciosPorDia[fechaAPreciosKey(date)];
                                            return (
                                                <>
                                                    {day}
                                                    <small className="bh-precio-dia-picker">
                                                        {precio > 0
                                                            ? Math.round(precio / 100) + '€'
                                                            : cargandoPrecios
                                                                ? <span className="bh-precio-dia-picker__spinner"></span>
                                                                : ' '}
                                                    </small>
                                                </>
                                            );
                                        }}
                                        calendarContainer={({ className, children }) => (
                                            <div className={className}>
                                                {cargandoPrecios && (
                                                    <div className="bh-precios-spinner" aria-live="polite">
                                                        <span className="bh-precios-spinner__dot"></span>
                                                        {t("Cargando precios")}...
                                                    </div>
                                                )}
                                                {children}
                                            </div>
                                        )}
                                    >
                                    </DatePicker>
                                    <div className="input-group-icon">
                                        <i className="fa-regular fa-calendar"></i>
                                    </div>
                                </div>
                                <div className="dropdown-menu c-search__inner">
                                    <div className="c-search__dropdown-content">
                                        <div className="c-search__dropdown-header">
                                            <p className="c-search__dropdown-header-title"> {t("Fecha entrada - salida")} </p>
                                            <button type="button" ngbdropdowntoggle="" className="dropdown-toggle btn btn-close" aria-expanded="false">
                                                <span className="visually-hidden">{t("Cerrar")}</span>
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="dropdown">
                                <div className="input-group">
                                    <div onClick={handleShow} className="dropdown-toggle form-control" ref={numpersonas}> 1 {t("Adulto")}</div>
                                    <div className="input-group-icon">
                                        <i className="fa-solid fa-user"></i>
                                    </div>
                                </div>
                                <div className={`dropdown-menu c-search__inner c-search__inner-room ${show !== '' && 'show'}`}>
                                    <div className="c-search__dropdown-dialog">
                                        <div className="c-search__dropdown-content">
                                            <div className="c-search__dropdown-header">
                                                <p className="c-search__dropdown-header-title"> {t("Habitaciones")} </p>
                                                <button type="button" ngbdropdowntoggle="" className="dropdown-toggle btn btn-close" aria-expanded="false">
                                                    <span className="visually-hidden">{t("Cerrar")}</span>
                                                </button>
                                            </div>
                                            <div className="c-search__dropdown-body">
                                                <div className="habitaciones">
                                                    <div className="c-search__inner-room_overflow">
                                                        <div className="c-search__room">
                                                            <div className="c-search__room-row flex-column flex-md-row">
                                                                <div className="c-search__room-col w-xs-100 w-100">
                                                                    <label htmlFor="n_adults_room0">{t("ADULTOS")}</label>
                                                                    <div className="c-search__room-input-group">
                                                                        <button type="button" className="btn btn-circle" onClick={handleRestaAdultos}>-</button>
                                                                        <input type="text" className="c-search__room-input" value={countAdults} min="1" max={capacidad_maxima} id="numadultos" readOnly={true} name="adultos" />
                                                                        <button type="button" className="btn btn-circle" onClick={handleSumaAdultos}>+</button>
                                                                    </div>
                                                                </div>
                                                                <div className="c-search__room-col w-xs-100 w-100">
                                                                    <label htmlFor="n_childs_room0">{t("NIÑOS")}</label>
                                                                    <div className="c-search__room-input-group">
                                                                        <button type="button" className="btn btn-circle" onClick={handleRestaNinos}>-</button>
                                                                        <input type="text" className="c-search__room-input" value={countNinos} min="1" max={capacidad_maxima} id="numninos" readOnly={true} name="ninos" />
                                                                        <button type="button" className="btn btn-circle" onClick={handleSumaNinos}>+</button>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="c-search__dropdown-footer">
                                                <div className="c-search__room-btn">
                                                    <button type="button" ngbdropdowntoggle="" className="dropdown-toggle btn w-100 btn-primary" aria-expanded="false">{t("Confirmar")}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                            <div className="input-group">
                                <input type="text" maxLength="20" codigopromocionalfiler="" className="form-control ng-untouched ng-pristine ng-valid" placeholder="Código promocional" />
                                <div className="input-group-icon">
                                    <i className="fa-solid fa-percent"></i>
                                </div>
                            </div>
                            <button type="buttsubmiton" className="btn btn-primary">{t("BUSCAR")}</button>
                        </div>

                    </div>


                </form>
                <button type="submit" className="btn btn-primary"> {t("BUSCAR")} </button>
            </div >

        </section >
    );
}

export default Buscador;
